/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Faq_DescriptionInputs */

const en_directory_ai_tools_faq_description = /** @type {(inputs: Directory_Ai_Tools_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything about photos, pricing and refunds. Still stuck?`)
};

const zh_directory_ai_tools_faq_description = /** @type {(inputs: Directory_Ai_Tools_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于照片、价格和退款的问题都在这里。还有疑问？`)
};

/**
* | output |
* | --- |
* | "Everything about photos, pricing and refunds. Still stuck?" |
*
* @param {Directory_Ai_Tools_Faq_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_faq_description = /** @type {((inputs?: Directory_Ai_Tools_Faq_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Faq_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_faq_description(inputs)
	return zh_directory_ai_tools_faq_description(inputs)
});
export { directory_ai_tools_faq_description as "directory.ai_tools.faq_description" }